var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.se_puede_reabrir)?_c('btn-loader',{staticClass:"m-l-10",attrs:{"variant":"success","text":"Re abrir","loader":_vm.loading},on:{"clicked":_vm.reabirir_caja}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }